import { ApiError } from './api'

// Server-sent error text when the response carried one, else the fallback.
export function apiErrorMessage(e: unknown, fallback: string): string {
  if (!(e instanceof ApiError)) return fallback
  const body = e.body as { error?: unknown; errors?: unknown } | null
  const hasText = typeof body?.error === 'string' || Array.isArray(body?.errors)
  return hasText && e.message ? e.message : fallback
}
